module.exports = __webpack_public_path__ + "img/IMG_8981_FoamcoreMatted.87c0a297.jpg";